var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Map',{attrs:{"hideCancelButton":_vm.hideCancelButton,"mapHeight":"50vh"}})
}
var staticRenderFns = []

export { render, staticRenderFns }